//import api from 'api-client'
import api from 'api-client'

const state = {
    companies: [],
    adminOrderhistoryFilters: [],
    newOrderCount: 0,
    startTime: null,
    eventBaseGroups: []
}
const getters = {
    companies: state => state.companies,
    newOrderCount: state => state.newOrderCount,
    adminOrderhistoryFilters: state => state.adminOrderhistoryFilters,
    eventBaseGroups: state => state.eventBaseGroups
}

const mutations = {
    companies (state, companies) {
        state.companies = companies
    },
    newOrderCount (state, val) {
        state.newOrderCount = val
    },
    startTime (state, val) {
        state.startTime = val
    },
    adminOrderhistoryFilters (state, val) {
        state.adminOrderhistoryFilters = val
    },
    eventBaseGroups (state, eventBaseGroups) {
        state.eventBaseGroups = eventBaseGroups
    }
}

const actions = {
    getCompanies({ commit }) {
        api.getCompanies()
            .then(result => commit('companies', result))
    },
    reloadCompanies () {
        return api.reloadCompanies()
    },
    reloadEvents () {
        return api.reloadEvents()
    },
    reloadGuests () {
        return api.reloadGuests()
    },
    reloadTicketRequests () {
        return api.reloadTicketRequests()
    },
    setNewOrderCount ({commit}, val) {
        commit('newOrderCount', val)
    },
    getAdminOrderhistoryFilters ({ commit }) {
        return api.getAllOrderhistoryFilters()
            .then(result => commit('adminOrderhistoryFilters', result))
    },
    'SOCKET_hello' ({ commit, state }, data) {
        if (state.startTime !== null && state.startTime < data) {
            window.location.reload()
        } else {
            commit('startTime', data)
        }
    },
    'SOCKET_reporting.refreshed' ({ commit, state, dispatch }, data) {
        dispatch('refreshReportingData')
    },
    getEventBaseGroups ({ commit }) {
        api.getEventBaseGroups()
            .then(result => commit('eventBaseGroups', result))
    }
}

export default {
    state, getters, mutations, actions
}
